<template>
  <div class="nodata">
    <p class="nodata-message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'NoAvailableData',
  props: {
    message: {
      type: String,
      default: 'No data available for this indicator, data source, and location combination.',
    },
  },
};
</script>

<style lang="scss" scoped>
.nodata {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nodata-message {
  text-align: center;
  color: #656565;
  font-size: 13px;
  margin: 0;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
}
</style>
